module.exports = __webpack_public_path__ + "img/intro_uk.a76b863d.svg";